// Small inline button that copies a given string to the clipboard and
// briefly flashes ✓ to confirm. Used wherever the tenant needs to copy
// payment details (UPI ID, bank account number, IFSC, bank name, etc.).
//
// Falls back gracefully if the Clipboard API isn't available (older
// browsers, insecure contexts) by selecting a hidden textarea and
// running document.execCommand('copy').

import React, { useState } from "react";

export default function CopyBtn({ value, label, h, size = "sm" }) {
    const [copied, setCopied] = useState(false);

    const onCopy = async (e) => {
        e?.stopPropagation?.();
        e?.preventDefault?.();
        const text = String(value ?? "").trim();
        if (!text) return;
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
            } else {
                // Fallback for non-secure contexts (e.g. old Android WebViews)
                const ta = document.createElement("textarea");
                ta.value = text;
                ta.setAttribute("readonly", "");
                ta.style.position = "absolute";
                ta.style.left = "-9999px";
                document.body.appendChild(ta);
                ta.select();
                document.execCommand("copy");
                document.body.removeChild(ta);
            }
            setCopied(true);
            setTimeout(() => setCopied(false), 1400);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    const isLg = size === "lg";
    const ac = h?.ac || "#3b82f6";
    const gn = h?.gn || "#16a34a";

    return (
        <button
            type="button"
            onClick={onCopy}
            aria-label={label ? `Copy ${label}` : "Copy"}
            title={label ? `Copy ${label}` : "Copy"}
            style={{
                background: copied ? `${gn}15` : "transparent",
                border: `1px solid ${copied ? gn : (h?.bd || "rgba(0,0,0,0.1)")}`,
                color: copied ? gn : ac,
                cursor: "pointer",
                padding: isLg ? "6px 10px" : "3px 8px",
                fontSize: isLg ? 12 : 11,
                fontWeight: 600,
                borderRadius: 6,
                lineHeight: 1.2,
                transition: "all 0.15s ease",
                whiteSpace: "nowrap",
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
            }}
        >
            {copied ? "✓ Copied" : "📋 Copy"}
        </button>
    );
}
